import { BLAdminWithPermissions } from '@/connection/access/get-channel-access';
import { Access, UserAccess } from '@/access/access';
import { SerializedUserAccess } from './types';

export const requestDataToUserAccess = (user: BLAdminWithPermissions): SerializedUserAccess => {
  const userAccess = new UserAccess(
    user.email,
    user.user_access.map((access) => Access.fromPermissionStatement(access)),
    user
  );
  return userAccess.toJSON();
};
